const ADMIN_EMAILS = ["jdevill@hotmail.com"]; // ← pon tu email aquí

// Solo controla si se muestra la UI de admin. El permiso real lo hace
// la RLS de Supabase contra profiles.is_admin (ver database/security_fix_admin_rls.sql).
export function isAdmin(user, profile) {
  return (user && ADMIN_EMAILS.includes(user.email)) || (profile && profile.is_admin === true);
}
